import React from "react"
import {findDOMNode} from "react-dom"

import FieldTimeOfDay_DropdownPopoverOptionsSelector from "./popover-options-selector"
import VScroll from "../../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import Popover from "../../../../../../gd-components/gd-popover/popover"
import ModelEntity from "../../../../../../model2/model-entity"
import FieldTimeOfDay_PopoverValue from "./popover-value"
import FieldTimeOfDay from "../../time-of-day"

type Props = {
    parent  : any,          // this is a view with props...
    field   : FieldTimeOfDay,
    model?  : ModelEntity
    value   : any
}

const debug = false
// const debug = "FieldTimeOfDay_PopoverMenu"

export default class FieldTimeOfDay_PopoverMenu extends React.Component<Props,any> {

    private refInput            : React.RefObject<any> = React.createRef<any>()
    private refScroll           : React.RefObject<any> = React.createRef<any>()
    private refOptionsSelector  : React.RefObject<any> = React.createRef<any>()
    public  scroll               : any

    onOptionHighlighted = (option:any) => {
        debug && console.log(debug, 'onOptionHighlighted', option)
        // update input according to highlighted option
        this.refInput.current.setInput(option)
    }

    onOptionClick = (option:any) => {
        debug && console.log(debug, 'onOptionClick', option)
        this.props.parent.onOptionClick(option)
    }

    onPopoverKeyDown = (e:any) => {
        debug && console.log(debug, 'onPopoverKeyDown')
        if(this.refOptionsSelector.current) this.refOptionsSelector.current.onPopoverKeyDown(e)
    }

    onInputChange = (value:any) => {
        debug && console.log(debug, 'onInputChange')
        this.props.parent.setValue(value)
    }

    updateScroll = (node:any, isCentered = false) => {
        debug && console.log(debug, "updateScroll", node, isCentered, this.refScroll.current)

        if (!node || !this.refScroll.current) return

        const scrollNode:any = findDOMNode(this.refScroll.current.childrenContainer)

        const nodeTop       = node.offsetTop
        const nodeBottom    = node.offsetTop + node.offsetHeight
        const scrollTop     = scrollNode?.scrollTop
        const scrollBottom  = scrollNode?.scrollTop + scrollNode?.offsetHeight

        debug && console.log(debug, "updateScroll", scrollBottom < nodeBottom, scrollTop > nodeTop)

        // ensure node to be in visible area of scroll
        if (isCentered)                     this.refScroll.current.setScrollTop((nodeTop + nodeBottom) / 2, true, 0)
        else if (scrollBottom < nodeBottom) this.refScroll.current.setScrollTop(nodeBottom - scrollNode?.offsetHeight, false, 100)
        else if (scrollTop > nodeTop)       this.refScroll.current.setScrollTop(nodeTop, false, 100)
    }

    render() {
        // const isManager = gd.ac.check.company.isManager()

        return (
            <Popover className          = "time-of-day-popover-menu"
                     attachment         = "top center"
                     targetAttachment   = "bottom center"
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>

                <FieldTimeOfDay_PopoverValue ref  = {this.refInput}
                                             {...this.props}
                                             onChange   = {this.onInputChange} />

                <div className={Classes("ui5-popover-menu", this.props.field.classes.PopoverMenu)}>
                    <VScroll ref                = {this.refScroll}
                             minDragHeight      = {20}
                             containerClass     = {this.props.field.classes.PopoverMenuScrollContainer}
                             scrollVisibility   = "auto">
                        <FieldTimeOfDay_DropdownPopoverOptionsSelector ref                 = {this.refOptionsSelector}
                                                                       {...this.props}
                                                                       highlightedOption   = {this.props.field.getMatchingOption(this.props.model, {isMandatory: true, closestMatch: true})}
                                                                       currentOption       = {this.props.field.getMatchingOption(this.props.model)}
                                                                       onUpdateScroll      = {this.updateScroll}
                                                                       onOptionHighlighted = {this.onOptionHighlighted}
                                                                       onOptionClick       = {this.onOptionClick}/>
                    </VScroll>
                </div>
            </Popover>
        )
    }
}
